import { Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';
import TableEmptyContent from '../../../../components/Text/TableEmptyContent';
import { TranslationsKeys } from '../../../../locales/translations';
import { useColumnsStudentFileList } from '../hooks/useColumnsStudentFileList';
import SearchFilters from './SearchFilters';
import {
  ITEMS_PER_PAGE,
  useStudentFileListLoader,
} from './StudentFileListLoader';

export default function StudentFile() {
  const { data, query, updateQuery, loading } = useStudentFileListLoader();
  const { t } = useTranslation(TranslationsKeys.STUDENT_FILE);

  const columns = useColumnsStudentFileList();

  return (
    <Card className="p-4 mt-2 mx-3">
      <Row>
        <Col xs={12}>
          <h1 className="fs-22 text-primary fw-700">{t('title')}</h1>
          <SearchFilters
            onSearch={(filters) => updateQuery({ ...query, ...filters })}
          />
        </Col>
        <Col xs={12}>
          <Table
            columns={columns}
            data={data.data}
            pagination={{
              currentPage: query.page,
              totalItems: data?.total ?? 0,
              totalPages: data?.total_pages ?? 0,
              itemsPerPage: ITEMS_PER_PAGE,
              onChangePage: (page: number) => updateQuery({ ...query, page }),
            }}
            isLoadingResults={loading}
            noResultsText={
              <TableEmptyContent
                title={t(
                  `${
                    Object.keys(query).length
                      ? 'table.noResults.title'
                      : 'table.noSearch.title'
                  }`,
                )}
                subtitle={t(
                  `${
                    Object.keys(query).length
                      ? 'table.noResults.body'
                      : 'table.noSearch.body'
                  }`,
                )}
              />
            }
          />
        </Col>
      </Row>
    </Card>
  );
}
